module.exports = "https://trybtryb-legacy.web.app/img/thinking-like-entrepeuner-mobile.23498ca0.webp";